import { DEMAND, DEMAND_PARTNER, ROUTES, SUPPLY, SUPPLY_PARTNER } from "../../assets/const/reportTypeConst";


export const getReportPageUrlByType = (type) => {
    let route = "/";
    switch (type) {
        case SUPPLY:
            route = '/reports/supply';
            break;
        case DEMAND:
            route = '/reports/demand';
            break;
        case DEMAND_PARTNER:
            route = '/reports/demand-partner';
            break;
        case ROUTES:
            route = '/reports/routes';
            break;
        case SUPPLY_PARTNER:
        default:
            route = '/reports/supply-partner';
            break;
    }
    return route;
};
